import React from 'react'

// TODO: Configure dev and production to fetch these from the /static folder.
import Bar from '../../svg/map/bar.svg'
import Bikeshare from '../../svg/map/bikeshare.svg'
import CarRental from '../../svg/map/car-rental.svg'
import Coffee from '../../svg/map/coffee.svg'
import Coworking from '../../svg/map/coworking.svg'
import Delivery from '../../svg/map/delivery.svg'
import EventSpace from '../../svg/map/event-space.svg'
import Grocery from '../../svg/map/grocery.svg'
import GuestBedroom from '../../svg/map/guest-bedroom.svg'
import Gym from '../../svg/map/gym.svg'
import LargeHostingKitchen from '../../svg/map/large-hosting-kitchen.svg'
import LightRail from '../../svg/map/light-rail.svg'
import MarketHall from '../../svg/map/market-hall.svg'
import Office from '../../svg/map/office.svg'
import RecordingStudio from '../../svg/map/recording-studio.svg'
import Restaurant from '../../svg/map/restaurant.svg'
import Rideshare from '../../svg/map/rideshare.svg'
import Scooter from '../../svg/map/scooter.svg'
import StorageUnit from '../../svg/map/storage-unit.svg'
import useSVGPublicURL from './utils/useSVGPublicURL'

interface SVGIconProps {
  alt?: string
  className?: string
  name?: string
  height?: string
  width?: string
  loading?: 'lazy' | 'eager'
}

/**
 * SVGIcon uses a static query via the `useSVGPublicURL` custom hook. The SVG files being referred to must be in the
 * `/svg-public-url` folder.
 * @param name The name of the SVG file without the .svg file extension. The component finds the icon by {name}.svg.
 * @param otherProps [optionalArg] These props are spread into the imported SVG, and can be used to set height, width, etc.
 */
const SVGIcon: React.FC<SVGIconProps & React.HTMLAttributes<HTMLImageElement>> = (props: SVGIconProps) => {
  const iconURL = useSVGPublicURL(props.name || '')
  if (!props.name) {
    return null
  }
  return <img src={iconURL} {...props} />
}

/**
 * SVGMapIcon imports all of our map icons from the svg/map folder. It allows us to import an SVG icon, and not worry about using/maintaining relative import paths.
 * @param name The name of the SVG file without the .svg file extension. The component imports the icon by {name}.svg.
 * @param otherProps [optionalArg] These props are spread into the imported SVG, and can be used to set height, width, etc.
 */
export const SVGMapIcon = (props: SVGIconProps) => {
  const {name} = props
  switch (name) {
    case 'bar':
      return <Bar {...props} />
    case 'bikeshare':
      return <Bikeshare {...props} />
    case 'car-rental':
      return <CarRental {...props} />
    case 'coffee':
      return <Coffee {...props} />
    case 'coworking':
      return <Coworking {...props} />
    case 'delivery':
      return <Delivery {...props} />
    case 'event-space':
      return <EventSpace {...props} />
    case 'grocery':
      return <Grocery {...props} />
    case 'guest-bedroom':
      return <GuestBedroom {...props} />
    case 'gym':
      return <Gym {...props} />
    case 'large-hosting-kitchen':
      return <LargeHostingKitchen {...props} />
    case 'light-rail':
      return <LightRail {...props} />
    case 'market-hall':
      return <MarketHall {...props} />
    case 'office':
      return <Office {...props} />
    case 'recording-studio':
      return <RecordingStudio {...props} />
    case 'restaurant':
      return <Restaurant {...props} />
    case 'rideshare':
      return <Rideshare {...props} />
    case 'scooter':
      return <Scooter {...props} />
    case 'storage-unit':
      return <StorageUnit {...props} />
    default:
      return null
  }
}

export default SVGIcon
